module.exports = __webpack_public_path__ + "static/img/aman-nyaman.3bed284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/aman-nyaman.png
// module id = jJFm
// module chunks = 1